export default __webpack_public_path__ + "static/media/license-info-exclusive.aeef89de.png";